import style from "../../../../assets/scss/sub/purchase/orderAndPayment.module.scss";
import CartProductItems from "../CartProductItems";
import React from "react";
import {useAppSelector} from "../../../../hooks/hooks";
import {cartedProducts} from "../../../../store/cart/cartSlice";
import {useTranslation} from "react-i18next";

export function OrderProductsField() {
    const { t } = useTranslation("order");
    const cartedProductList = useAppSelector(cartedProducts);

    return (
        <div className={style.orderAndPaymentWrapper}>
            <div className={style.orderItemList}>
                <h3 className={style.sectionTitle}>{t("cart.title")}</h3>
                <CartProductItems cartedProducts={cartedProductList ?? []}/>
            </div>
        </div>
    )
}